<template>
  <b-container class="mt-5">
    <b-row>
      <b-col offset="0" cols="12" offset-md="3" md="6">
        <sign-in-form />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import {mapGetters} from 'vuex'
import SignInForm from '../components/SignInForm'
export default {
  components: {
    SignInForm
  },
  computed: {
    ...mapGetters(['user']),
    nextRoute () {
      return this.$route.query.redirect || '/dashboard'
    }
  },
  data () {
    return {
      login: '',
      password: ''
    }
  },
  watch: {
    user (auth) {
      if(!!auth){
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async onSubmit () {
      await this.$auth.login(this.login, this.password)
    }
  }
}
</script>